import { apiGet, apiPut } from "../apiClient";
import { OrgEmailPreferences } from "@eip/shared/types";

export type OrgEmailSettingsResponse = {
  success: boolean;
  // Server returns the fully-resolved registry map (missing stored keys read as enabled)
  preferences: Record<string, boolean>;
};

export const getOrgEmailSettings = () =>
  apiGet<OrgEmailSettingsResponse>("/api/admins/email-notification-settings");

export const updateOrgEmailSettings = (preferences: OrgEmailPreferences) =>
  apiPut<OrgEmailSettingsResponse>("/api/admins/email-notification-settings", { preferences });
